<template lang="pug">
  .popup-uploader
    .popup-uploadImage.popup-uploadNameCard
      .popup-imageUploadImage(
        :style='defaultImage' 
        alt='image-placehoder'
        ref="imagePreview"
        )

      // show this before image's uploaded  and remove when image's uploaded

      span.popup-textUploadImage(v-if='!this.isImageUploaded')
        | 檔案可支援類型 .jpg, .png, .pdf，檔案大小請於100MB以內。
        
      div.popup-textUploadImage(v-else)
        span.popup-fileName.ellipsis-single {{fileName}}
        button.popup-buttonClear(@click="clearUpload" ) 刪除檔案
        
      // loading
      loading(loader='dots', :active.sync='isLoading', :is-full-page='false')

      .popup-uploadImageRight
        .custom-file
          input#file-uploader.custom-file-input(type='file', data-target='file-uploader', @change='handleFileUpload')
          button.custom-file-label.popup-label--mobile(for='customFile')
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'
import { getCategoryImgURL } from '@/plugins/tool.js'
import { checkPopupAlert } from '@/plugins/tool.js'

export default {
  name: "ImageUploadArticleImage",
  components: {
    Loading
  },
  props: {
    govAnnounceImageUrl: {
      type: String,
      default: () => ''
    },
    defaultThumbCaption: {
      tpe: String,
      default: () => ''
    }
  },
  data(){
    return {
      isActive: false,
      isLoading: false,
      contentLimit: 40,
      alert: {
        thumbTitle: {
          textarea: "popup-textarea",
          alertText: false,
          counter: "popup-counter"
        }
      },
      params: {
        thumbTitle: this.defaultThumbCaption
      },
      isImageUploaded: false,
      fileName: '',
    }
  },
  computed: {
    defaultImage() {
      if(!this.govAnnounceImageUrl)
        return "background-image: url('" + getCategoryImgURL("/fig-default-2.png") + "');"
      else
        return "background-image: url('" + this.govAnnounceImageUrl + "');"
    }
  },
  methods: {
    async handleFileUpload(e) {
      try {
        const file = e.target.files[0];
        this.setUploading(true);
        if (!file) return;

        const beforeUploadCheck = await this.beforeUpload(file);
        if (!beforeUploadCheck.isValid) throw beforeUploadCheck.errorMessages;

        const arrayBuffer = await this.getArrayBuffer(file);
        await this.uploadFileAJAX(arrayBuffer);
        this.showPreviewImage(file);
        this.$emit("uploadImg", file)
      } catch (error) {
        alert(error);
      } finally {
        e.target.value = '';  // reset input file
        this.setUploading(false);
      }
    },

    // STEP 2: showPreviewImage with createObjectURL
    // If you prefer Base64 image, use "FileReader.readAsDataURL"

    showPreviewImage(fileObj) {
      let imagePreview = this.$refs.imagePreview
      const image = URL.createObjectURL(fileObj);

      // set this prop to true so we can
      // 1. hide Upload Text,
      // 2. show the uploaded image's thumbnail, and the textarea for image title
      this.isImageUploaded = true

      this.fileName =  fileObj.name

      imagePreview.style['background-image'] = "url('" + image + "')"
      // imagePreview.src = image;

    },

    // STEP 3: change file object into ArrayBuffer
    getArrayBuffer(fileObj) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // Get ArrayBuffer when FileReader on load
        reader.addEventListener("load", () => {
          resolve(reader.result);
        });

        // Get Error when FileReader on error
        reader.addEventListener("error", () => {
          reject("error occurred in getArrayBuffer");
        });

        // read the blob object as ArrayBuffer
        // if you nedd Base64, use reader.readAsDataURL
        reader.readAsArrayBuffer(fileObj);
      });
    },

    // STEP 4: upload file throguth AJAX
    // - use "new Uint8Array()"" to change ArrayBuffer into TypedArray
    // - TypedArray is not a truely Array,
    //   use "Array.from()" to change it into Array
    uploadFileAJAX(arrayBuffer) {
      // correct it to your own API endpoint
      return fetch("https://jsonplaceholder.typicode.com/posts/", {
        headers: {
          version: 1,
          "content-type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
          imageId: 1,
          icon: Array.from(new Uint8Array(arrayBuffer))
        })
      })
      .then(res => {
        if (!res.ok) {
          throw res.statusText;
        }
        return res.json();
      })
      .then(data => data)
      .catch(err => {
        /* eslint-disable */
        console.log("err", err)
      });
    },

    // STEP 5: Create before upload checker if needed
    beforeUpload(fileObject) {
      return new Promise(resolve => {
        const validFileTypes = ["image/jpeg", "image/png"];
        const isValidFileType = validFileTypes.includes(fileObject.type);
        let errorMessages = [];

        if (!isValidFileType) {
          errorMessages.push("You can only upload JPG or PNG file!");
        }

        const isValidFileSize = fileObject.size / 1024 / 1024 < 5;
        if (!isValidFileSize) {
          errorMessages.push("Image must smaller than 5MB!");
        }

        resolve({
          isValid: isValidFileType && isValidFileSize,
          errorMessages: errorMessages.join("\n")
        });
      });
    },

    setUploading(isUploading) {
      if (isUploading === true) this.isLoading = true
      else this.isLoading = false
    },
    checkActive() {
      this.alert.content = checkPopupAlert(this.params.thumbTitle.length > this.contentLimit, this.alert.content)
      if (this.params.thumbTitle.length <= this.contentLimit) {
        this.isActive = true
      }
      else {
        this.isActive = false
      }
    },
    resetThumbnail() {
      this.$refs.imagePreview.style = "background-image: url('" + getCategoryImgURL("/fig-default-2.png") + "');" 
    },
    clearUpload() {
      this.resetThumbnail()
      this.fileName = ''
      this.params.thumbTitle = ''
      this.isImageUploaded = false
    },
    updateThumbTitle() {
      this.$emit('setThumbTitle', this.params.thumbTitle)
    }
  }
}
</script>

<style scoped src="./image_upload_name_card.vue.css"></style>
